import { MenuItem, Tab, Tabs, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import useIsMobile from '../hooks/useIsMobile'

const tabs = [
  { label: "To-Do's", path: 'todos' },
  { label: 'Documents', path: 'documents' },
  { label: 'Strategy', path: 'strategy' },
  { label: 'Events', path: 'events' },
  { label: 'Activity Reports', path: 'activity' },
]

const DashboardTabs = () => {
  const navigate = useNavigate()
  const { subPath } = useParams()

  const [tab, setTab] = useState(tabs.map((t) => t.path).indexOf(subPath))

  const handleTabChange = (_, i) => {
    setTab(i)
    navigate(`/dashboard/${tabs[i].path}`)
  }

  useEffect(() => {
    const newIndex = tabs.map((t) => t.path).indexOf(subPath)
    if (tab !== newIndex) setTab(newIndex)
  }, [subPath])

  const isMobile = useIsMobile()
  if (isMobile)
    return (
      <TextField
        size='small'
        sx={{ ml: '42px', mb: 2 }}
        select
        value={tab}
        onChange={(e) => handleTabChange(null, e.target.value)}
      >
        {tabs.map((t, i) => (
          <MenuItem value={i}>{t.label}</MenuItem>
        ))}
      </TextField>
    )

  return (
    <Tabs
      sx={{
        backgroundColor: 'white',
        boxShadow: '0 7px 9px -7px rgb(0 0 0 / 40%)',
      }}
      value={tab}
      onChange={handleTabChange}
    >
      {tabs.map((t) => (
        <Tab key={t.label} label={t.label}></Tab>
      ))}
    </Tabs>
  )
}

export default DashboardTabs
